import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { DndProvider } from 'react-dnd-multi-backend';

import { useTitle } from '../../components';
import CallsProvider from '../../stores/calls/CallsProvider';
import CasesProvider from '../../stores/cases/CasesProvider';
import MediaProvider from '../../stores/media/MediaProvider';

import Dashboard from './Dashboard';

function DashboardWrapped() {
  useTitle('Paxity');

  return (
    <DndProvider options={HTML5toTouch}>
      <CasesProvider>
        <CallsProvider>
          <MediaProvider>
            <Dashboard />
          </MediaProvider>
        </CallsProvider>
      </CasesProvider>
    </DndProvider>
  );
}

export default DashboardWrapped;
